import React from "react";
import { Link } from "react-router-dom";
import "./ProjectCard.scss";
const ProjectCard = ({ image, text, title, link }) => {
  return (
    <div className="feature-card mx-auto mt-3 mb-5 col-md-3">
      <div className="card">
        <img src={image} className="card-img-top feature-img" alt="..." />
        <div className="card-body featue-body p-0">
          <h5 className="card-title mt-2">{title}</h5>
          <Link className="btn btn-success view-btn" to={link}>
            View
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
